import { Edge, Node, XYPosition } from "reactflow";
import { PortInfo } from ".";
import { BdaApplication } from "../models/BdaApplication";
import { BdaService } from "../models/BdaService";
import { UsedItem } from "../models/generics";

const PROPERTY_CAPTURING_REGEX = /(?<type>input|output)-(?<asset>dataset|model)/;

export interface GraphV2 {
  nodes: Node[];
  edges: Edge[];
}

export function translateGraph(graph: any[]): GraphV2 {
  return graph.reduce<GraphV2>((acc, curr) => {
    if (Object.hasOwn(curr, 'source') && Object.hasOwn(curr, 'target')) acc.edges.push(curr);
    else acc.nodes.push(curr);
    return acc;
  }, { nodes: [], edges: [] });
}

export function validateConnection(source: string, target: string) {
  const { groups: sourceGroups } = source.match(PROPERTY_CAPTURING_REGEX)!;
  const { groups: targetGroups } = target.match(PROPERTY_CAPTURING_REGEX)!;

  return sourceGroups?.asset === targetGroups?.asset;
}

export function isStreamService(service: any) {
  return service.mode === 'SINK' || service.mode === 'SOURCE' || service.mode === 'PROCESSOR';
}

export function getNodeId(node: any) {
  return getIdFromUUID(node.id);
}

export function getIdFromUUID(uuid: string) {
  const stringID = uuid.split('__')[0];
  return Number.parseInt(stringID);
}

export function getNodeFromUUID(uuid: string, elements: any[]) {
  const id = getIdFromUUID(uuid);
  return elements.find(element => element.id === id);
}

export function validateApplication(application: BdaApplication) {
  const errors = application.workflows[0].services
    .map(service => {
      const missingProperties = service.properties
        .filter(prop => !prop.invisible && prop.mandatory && (prop.value === null || prop.value === ""))
        .map(prop => prop.key);

      return {
        service: service.name,
        missingProperties,
      };
    })
    .filter(item => item.missingProperties.length > 0);

  return {
    valid: errors.length === 0,
    errors,
  }
}

export type Graph = (Node & Edge)[];

export interface NewNode {
  id: string;
  type: string;
  position: XYPosition;
  data: any;
}

export function generateItemFromPortInfo(portInfo: PortInfo, edges: Edge[], usedItems: UsedItem<any>[]): UsedItem<any> {
  const service = usedItems.find(item => item.ref === portInfo.nodeId) as UsedItem<BdaService>;

  if (portInfo.id.includes('input-dataset')) {
    const connection = edges.find(link => link.target === portInfo.nodeId && link.targetHandle === portInfo.id);

    // if (!connection) return;

    if (connection?.sourceHandle?.includes('output-dataset')) return { isNodePort: true, cascade: true, type: portInfo.id, name: `${portInfo.nodeName} - ${portInfo.id}`, service };

    // if (service.inputs?.find(input => input.id === portInfo.id)?.dataset?.type !== "table") return;

  }
  else if (portInfo.id.includes('output-dataset') || portInfo.id.includes('output-model')) return { isNodePort: true, isOutput: true, type: portInfo.id, name: `${portInfo.nodeName} - ${portInfo.id}`, service };
  return { isNodePort: true, type: portInfo.id, name: `${portInfo.nodeName} - ${portInfo.id}`, service };
}

export function getNodeInputEdge(node: Node, edges: Edge[], port: string) {
  return edges.find(el => el.targetHandle === port && el.target === node.id);
}